import React from 'react';

export interface StatisticLabelProps {
    bold?: boolean;
    children: React.ReactNode;
    secondary?: boolean;
    className?: string;
    style?: React.CSSProperties;
}

const StatisticLabel: React.FC<StatisticLabelProps> = ({
    bold = false,
    children,
    secondary = false,
    className = '',
    style = {},
}) => {
    const labelStyles: React.CSSProperties = {
        fontSize: secondary ? '14px' : '16px',
        fontWeight: bold ? 600 : 400,
        color: secondary ? 'var(--malachite-text-dimmed)' : 'var(--malachite-text-primary)',
        lineHeight: '1.4',
        margin: 0,
        ...style,
    };

    return (
        <span className={className} style={labelStyles}>
            {children}
        </span>
    );
};

export default StatisticLabel;
